<div class="history-header">
  <h2 mat-dialog-title>{{'BED_STATES.HISTORY' | translate}} · {{bed.deviceLabel}}</h2>
  <button type="button" mat-dialog-close [attr.aria-label]="'BED_STATES.CLOSE' | translate">×</button>
</div>
<mat-dialog-content>
  @if (store.canView && !store.denied()) {
    <div class="period-buttons" role="group" [attr.aria-label]="'BED_STATES.PERIOD' | translate">
      <button type="button" (click)="selectPeriod(6)">{{'BED_STATES.LAST_6H' | translate}}</button>
      <button type="button" (click)="selectPeriod(24)">{{'BED_STATES.LAST_24H' | translate}}</button>
      <button type="button" (click)="selectPeriod(168)">{{'BED_STATES.LAST_7D' | translate}}</button>
    </div>
    <form class="range-form" (ngSubmit)="load()">
      <label>{{'BED_STATES.FROM' | translate}}<input name="from" type="datetime-local" step="1" required [(ngModel)]="fromInput"></label>
      <label>{{'BED_STATES.TO' | translate}}<input name="to" type="datetime-local" step="1" required [(ngModel)]="toInput"></label>
      <button type="submit" [disabled]="loading">{{'BED_STATES.APPLY' | translate}}</button>
    </form>
    <p class="timezone-note">{{'BED_STATES.INPUT_TIMEZONE' | translate: { timezone: inputTimezone } }}</p>
    @if (loading) {
      <p role="status">{{'BED_STATES.LOADING_HISTORY' | translate}}</p>
    } @else if (error) {
      <p class="error" role="alert">{{error | translate}}</p>
    } @else if (history; as result) {
      <div class="duration-summary">
        @for (item of summaryKeys; track item.key) {
          <div [class]="'summary-item ' + presentation(item.state).css">
            <app-bed-posture-icon [state]="item.state" />
            <span>{{presentation(item.state).label | translate}}</span>
            <strong>{{duration(result.summarySeconds[item.key])}}</strong>
          </div>
        }
      </div>
      <p class="timezone-note">{{'BED_STATES.RESULT_TIMEZONE' | translate: { timezone: result.timezone } }}</p>
      <ol class="intervals">
        @for (item of result.intervals.slice(0, visibleCount); track $index) {
          <li [class]="presentation(item.state).css">
            <app-bed-posture-icon [state]="item.state" />
            <div class="interval-copy">
              <strong>{{presentation(item.state).label | translate}} · {{intervalDuration(item)}}</strong>
              <span>{{formatDate(item.start)}} → {{formatDate(item.end ?? result.to)}}</span>
              @if (item.end === null) { <span>{{'BED_STATES.IN_PROGRESS' | translate}}</span> }
            </div>
          </li>
        } @empty {
          <li>{{'BED_STATES.NO_HISTORY' | translate}}</li>
        }
      </ol>
      @if (result.intervals.length > visibleCount) {
        <button type="button" (click)="visibleCount = visibleCount + 50">{{'BED_STATES.SHOW_MORE' | translate}}</button>
      }
    }
  } @else {
    <p role="alert">{{'BED_STATES.FORBIDDEN' | translate}}</p>
  }
</mat-dialog-content>
